import { Button, Form, Input } from 'antd'
import { FC } from 'react'
import { relayStore } from '../store/relay'
import { useNavigate, useParams } from 'react-router-dom'
import { RNRelay } from '../helpers/routeNames'
import { PageBreadcrumb } from '../components/PageBreadcrumb'
import { RelayOne } from '../helpers/types/relay'

export const CreateRelayOne: FC = () => {
	const [form] = Form.useForm()
	const { createRelayOne, relayTypes } = relayStore()
	const navigate = useNavigate()
	const { relayTypeId, relayId } = useParams()

	const handleSubmit = async (values: RelayOne) => {
		if (!relayTypeId || !relayId) return
		await createRelayOne({
			...values,
			relayTypeId,
			relayId
		})
		navigate(RNRelay + '/' + relayId)
	}

	const relayName = relayTypes
		.find((rt) => rt.id === relayTypeId)
		?.relays.find((r) => r.id === relayId)?.name

	return (
		<div>
			<PageBreadcrumb
				items={[
					{ label: 'Реле', path: RNRelay },
					{ label: relayName || 'Реле' },
					{ label: 'Создать экземпляр' }
				]}
			/>
			<header>
				<h1>Создать реле для работы</h1>
			</header>
			<main>
				<Form
					onFinish={handleSubmit}
					form={form}
					initialValues={{ relayTypeId, relayId }}>
					<Form.Item
						label="Тип реле"
						rules={[{ required: true }]}>
						<Input
							disabled
							value={
								relayTypes.find(
									(rt) => rt.id === relayTypeId
								)?.name
							}
						/>
					</Form.Item>
					<Form.Item
						label="Реле"
						rules={[{ required: true }]}>
						<Input
							disabled
							value={
								relayTypes
									.find(
										(rt) => rt.id === relayTypeId
									)
									?.relays.find(
										(r) => r.id === relayId
									)?.name
							}
						/>
					</Form.Item>
					<Form.Item
						label="Уникальный номер"
						name="relayUnique"
						rules={[{ required: true }]}>
						<Input allowClear />
					</Form.Item>
					<Form.Item
						label="Год выпуска"
						name="madeYear"
						rules={[{ required: true }]}>
						<Input allowClear />
					</Form.Item>
					<Form.Item>
						<Button htmlType="submit">Создать</Button>
					</Form.Item>
				</Form>
			</main>

			<style>{`
				section {
					padding: 0 1rem;
				}
			}`}</style>
		</div>
	)
}
